module.exports = __webpack_public_path__ + "img/france-lung-cancer-female.9f10e64d.png";